<template>
  <b-row>
    <b-col>
      <h6 class="compo-heading">{{ $t('5005.tax.tax') }}</h6>
    </b-col>
  </b-row>
  <div class="details-card">
    <b-row>
      <b-col lg="6" md="6" sm="12" cols="12">
        <div class="field">
          <TextInput name="Vattinno" id="Vattinno" :label="$t('5005.tax.vattinno')" v-model="taxdatadetails.VATNo"
            @change="input" />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" cols="12">
        <div class="field">
          <TextInput name="Servicetaxregno" id="Servicetaxregno" :label="$t('5005.tax.servicetaxregno')"
            v-model="taxdatadetails.ServiceTaxNo" @change="input" />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" cols="12">
        <div class="field">
          <TextInput name="Excercisecode" id="Excercisecode" :label="$t('5005.tax.excercisecode')"
            v-model="taxdatadetails.ExciseCode" @change="input" />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" cols="12">
        <div class="field">
          <TextInput name="Incometaxpan" id="Incometaxpan" :label="$t('5005.tax.incometaxpan')"
            v-model="taxdatadetails.IncomeTaxNo" :rules="{ alphanumeric: true, Pannumber: true }" @change="input" />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" cols="12">
        <div class="field">
          <TextInput name="Csttinno" id="Csttinno" :label="$t('5005.tax.Csttinno')" v-model="taxdatadetails.CST"
            @change="input" />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" cols="12">
        <div class="field">
          <TextInput :name="$t('5005.tax.gsttinno')" :id="$t('5005.tax.gsttinno')" :label="$t('5005.tax.gsttinno')"
            v-model="taxdatadetails.GSTNO" :rules="{ required: true }" :required-icon="true" />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" cols="12">
        <div class="field">
          <TextInput name="Msme" id="Msme" :label="$t('5005.tax.msme')" v-model="taxdatadetails.MSME" @change="input" />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" cols="12">
        <div class="field">
          <TextInput name="Rtgscode" id="Rtgscode" :label="$t('5005.tax.rtgscode')" v-model="taxdatadetails.RTGSCODE"
            @change="input" />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" cols="12">
        <div class="field">
          <TextInput name="Druglicence" id="Druglicence" :label="$t('5005.tax.druglicence')"
            v-model="taxdatadetails.DrugLicence" @change="input" />
        </div>
      </b-col>
    </b-row>
    <Toast />

  </div>
</template>

<script lang="ts">
import { value } from "dom7";
import { defineComponent, ref, reactive, toRefs, onMounted } from "vue";
import TextInput from "../../../../components/FormComponents/TextInput.vue";
import service from "../../../../modules/Inventory/Service/SupplierMaster";
import { useToast } from "primevue/usetoast";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";

import { alpha_num } from "@vee-validate/rules";
export default defineComponent({
  components: {
    TextInput,
  },
  props: {
    value: {},
  },

  setup(props, { emit }) {
    const taxdatadetails = reactive({
      VATNo: "",
      ServiceTaxNo: "",
      ExciseCode: "",
      IncomeTaxNo: "",
      CST: "",
      GST: "",
      MSME: "",
      RTGSCODE: "",
      DrugLicence: "",
      GSTNO: "",
    });
    const router = useRoute();
    const EditID = router.query.Id;
    const toast = useToast();
    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);

    onMounted(() => {
      Object.assign(taxdatadetails, props.value);
      input();
    });

    function input() {
      emit("update:modelValue", taxdatadetails);
    }
    async function GSTNOChk() {
      try {
        debugger;
        const response = await service.gettable();
        console.log(response["result"]);
        response["result"] = response["result"]
          .filter((items) => items.HospitalId == HospitalId && items.GSTNO == taxdatadetails.GSTNO && items.Id != (EditID || 0))
        if (response["result"].length > 0) {
          toast.add({
            severity: "warn",
            summary: "This GSTNO. is Already Used by another supplier!",
            detail: "",
            life: 3000,
          });
          taxdatadetails.GSTNO = ""
        }
      }
      catch (error) {
        console.log(error)
      }

    }
    return {
      input,
      taxdatadetails,
      GSTNOChk,
    };
  },
});
</script>
